import React from 'react'
import { CardActions, EditButton, Show } from 'react-admin'

import { CustomShowLayout } from '../Generic'

import { renderModelFields } from '../Fields'

const GenericShowActions = ({
    basePath,
    data,
    hasEdit,
    permissions,
    resource,
}) => {
    let canEdit = hasEdit

    if (permissions.role === 'coordinado') {
        const propietario = data && data.propietario
        const empresaId = resource === 'empresas'
            ? data && data.id
            : propietario && (propietario.id || propietario)
        const empresas = permissions.empresas || {}
        const empresa = empresaId && empresas[empresaId]

        canEdit = !!empresa
            && Array.isArray(empresa.permissions)
            && empresa.permissions.includes('edit')
    }

    return (
        <CardActions>
            {canEdit && <EditButton basePath={basePath} record={data} />}
        </CardActions>
    )
}

export const GenericShow = (props) => {
    if (!!props.fields && props.fields.length === 0) {
        return null
    } else if (props.permissions === null) {
        return null
    }

    return (
        <Show
            {...props}
            actions={<GenericShowActions permissions={props.permissions} />}
        >
            <CustomShowLayout title={props.title} schema={props.schema}>
                {renderModelFields(props.fields, props.permissions)}
            </CustomShowLayout>
        </Show>
    )
}
